import { DateTime } from "luxon";

export const formatDate = (date, format = "DD") => {
  if (!date) {
    return null;
  }
  return DateTime.fromISO(date).toFormat(format);
};
